module.exports = __webpack_public_path__ + "static/media/disability-incapacity.2344dc41.svg";